import { createContext } from "react";

export const UserProfile = createContext()